import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Circle, ArrowRight, X } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";

const HIDE_KEY = "setup_card_hidden";

export const SetupChecklist = () => {
  const { t } = useLang();
  const [s, setS] = useState(null);
  const [hidden, setHidden] = useState(localStorage.getItem(HIDE_KEY) === "1");
  useEffect(() => { api.get("/setup/status").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s || s.complete || hidden) return null;
  const done = s.steps.filter((x) => x.done).length;
  const next = s.steps.find((x) => !x.done)?.key;
  const hide = () => { localStorage.setItem(HIDE_KEY, "1"); setHidden(true); };

  return (
    <div className="card p-5 border-2 border-[#800B28]/20" data-testid="setup-checklist">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="eyebrow">{t("setup_eyebrow")}</p>
          <h2 className="text-xl font-extrabold mt-1">{t("setup_title")}</h2>
          <p className="text-sm text-slate-600 mt-1">{t("setup_sub")}</p>
        </div>
        <button className="btn-secondary btn-sm" onClick={hide} data-testid="setup-hide-button"><X size={14} />{t("setup_hide")}</button>
      </div>
      <div className="mt-4 h-2 rounded-full bg-slate-100 overflow-hidden" data-testid="setup-progress">
        <div className="h-full bg-[#800B28] transition-[width] duration-500" style={{ width: `${(done / s.steps.length) * 100}%` }} />
      </div>
      <p className="text-xs font-bold text-slate-500 mt-1" data-testid="setup-progress-text">{done} / {s.steps.length}</p>
      <ol className="mt-3 grid md:grid-cols-2 gap-2">
        {s.steps.map((x, i) => (
          <li key={x.key} data-testid={`setup-step-${x.key}`}
            className={`flex items-center gap-3 rounded-xl border px-3 py-2.5 ${x.key === next ? "border-[#800B28] bg-rose-50" : "border-slate-200"}`}>
            {x.done ? <CheckCircle2 size={22} className="text-emerald-600 shrink-0" /> : <Circle size={22} className="text-slate-300 shrink-0" />}
            <div className="flex-1 min-w-0">
              <p className={`font-bold text-sm ${x.done ? "text-slate-500 line-through" : ""}`}>{i + 1}. {t(`setup_${x.key}`)}</p>
              <p className="text-xs text-slate-500">{x.done ? `${x.count} ${t("setup_added")}` : t(`setup_${x.key}_hint`)}</p>
            </div>
            {!x.done && <Link to={x.link} className="btn-secondary btn-sm shrink-0" data-testid={`setup-go-${x.key}`}>{t("setup_go")}<ArrowRight size={14} /></Link>}
          </li>
        ))}
      </ol>
    </div>
  );
};
